import { useTranslation } from "react-i18next";
export { uiResources } from "./resources";
/**
 * UI namespace for @f2e/ui translations.
 * Apps should register this namespace with uiResources.
 */
export const UI_I18N_NAMESPACE = "ui";
/**
 * Hook for @f2e/ui internal components.
 * Wraps useTranslation with the UI namespace.
 */
export const useUiTranslation = () => {
    return useTranslation(UI_I18N_NAMESPACE);
};
//# sourceMappingURL=index.js.map